"use strict";

import React, {useState} from "react";
import ContactForm from "./component/ContactForm";
import axiosWrapper from "../axiosWrapper";
import OrderLookupContainer from "./component/OrderLookupContainer";
import FlashMessage from "../component/FlashMessage";

const Contact = (props) => {

    const [message, setMessage] = useState(null);
    const [formErrors, setFormErrors] = useState({});

    const handleFormSubmit = (url,data) => {
        return new Promise((resolve) => {
        axiosWrapper.post(url, data).then((response)=>{
            if (response?.data?.success) {
                let successData = response.data.success
                setMessage(successData);

                if (!!successData.redirect) {
                    window.location = successData.redirect;
                }
            }
            if (response?.data?.errors) {
                setFormErrors(response.data.errors);
            }
            resolve();
        })
            .catch((error)=>{
                console.log(error);
                let errorData = error.data;
                errorData.type='error';
                if (error?.data?.errors) {
                    setFormErrors(error.data.errors);
                }
                setMessage(error.data);

                if (!!errorData.redirect) {
                    setTimeout(function(){
                        window.location = errorData.redirect;
                    }, 500);
                }
                resolve();
            });
        });
    }

    if (!!message) {
        return(<>
                <FlashMessage {...message} />
            {!!message.orderNumber &&
                <OrderLookupContainer {...props}
                                 isTopsOrder={message.isTopsOrder}
                                 match={{params:{id:message.orderNumber,email:message.email}}}
                />
            }
        </>);
    } else {
        return (
            <>
                <ContactForm {...props}
                             handleFormSubmit={handleFormSubmit}
                             formErrors={formErrors}
                />
            </>
        );
    }
};

export default Contact;